import { useEffect, useState } from 'react'

const getNewNotice = () => {
  return localStorage.getItem('isNewNotice')
}

export const useNewNotice = () => {
  const [newNotice, setNewNotice] = useState(getNewNotice())

  useEffect(() => {
    const handleChangeStorage = () => {
      setNewNotice(getNewNotice())
    }

    window.addEventListener('storage', handleChangeStorage)

    return () => window.removeEventListener('storage', handleChangeStorage)
  }, [])

  return newNotice
}
